module.exports = __webpack_public_path__ + "footer-logo-en.jpg?482cdfa9dd700db0f988d1e47da8e367";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer-logo-en.jpg
// module id = 938
// module chunks = 0